module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-haven-fluted-balmoral-0.4eed02af.jpg";